var map = {
	"./arrow.svg": "nCIC",
	"./arrow2.svg": "oHZP",
	"./check.svg": "7ZS0",
	"./close.svg": "toIl",
	"./close2.svg": "E7Nu",
	"./error.svg": "KCO8",
	"./found.svg": "RlNO",
	"./help.svg": "35H+",
	"./huo.svg": "O6Em",
	"./login.svg": "j/EP",
	"./play.svg": "ufmG",
	"./play2.svg": "R83P",
	"./success.svg": "C5yd",
	"./tel.svg": "8EXL",
	"./time.svg": "RJM1",
	"./tips.svg": "D4Qx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 2